// SEO.js
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = "Bala Cabs - Premium Cab Services in Rajapalayam", 
  description = "Book reliable cab services in Rajapalayam. Outstation cabs, airport transfers, local sightseeing, and corporate travel services at best prices.",
  keywords = "cab services Rajapalayam, taxi service, outstation cabs, airport transfer, car rental",
  image = "https://balacab.com/Bala_Websitelogo3.png",
  url = "https://balacab.com",
  canonical = ""
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonical || url} />
      <meta property="og:site_name" content="Bala Travels" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical || url} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Bala Cabs",
          "image": "https://balacab.com/Bala_Websitelogo3.png",
          "@id": "https://balacab.com",
          "url": "https://balacab.com",
          "telephone": "+919150508183",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "SuntharaRaja Puram",
            "addressLocality": "Rajapalayam",
            "addressRegion": "Tamil Nadu",
            "postalCode": "626142",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 9.4328,
            "longitude": 77.4983
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday"
            ],
            "opens": "00:00",
            "closes": "23:59"
          },
          "sameAs": [
            "https://www.facebook.com/yourpage",
            "https://www.instagram.com/yourprofile",
            "https://twitter.com/yourprofile"
          ] 
        })}
      </script>
    </Helmet>
  );
};

export default SEO;